import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Separator } from '../../../../../../CommonComponents/OPL/Separator/Separator';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { InputNumberMask } from '../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormValues, Options } from './EstateTaxesChange.meta';

interface Props {
  options: Options;
}

export const EstateTaxesChange = ({ options }: Props) => {
  const formContext = useFormContext<FormValues>();

  const {
    control,
    formState: { errors },
  } = formContext;

  return (
    <>
      <Text fontSize="h5" fontWeight={600} px="12" py="16">
        What-if...
      </Text>

      <Separator />

      <Box p="16">
        {options.PrincipalHasEstateTax && (
          <>
            <Text>
              {options.PrincipalName}&apos;s {options.PrincipalFilingState} State Estate Tax
            </Text>

            <Controller
              control={control}
              name="StateTaxRate"
              render={({ field: fieldValue }) => (
                <InputNumberMask
                  {...fieldValue}
                  label="Effective Tax Rate"
                  placeholder="Effective Tax Rate"
                  rightIcon="far fa-percent"
                  decimalScale={2}
                  allowNegative={false}
                  thousandSeparator={false}
                  formVariant={errors.StateTaxRate ? 'error' : undefined}
                  helperText={errors.StateTaxRate?.message}
                  maxLength={3}
                />
              )}
            />

            <Controller
              control={control}
              name="StateTaxLowerLimitAmount"
              render={({ field: { value, onChange, ref } }) => (
                <InputNumberMask
                  ref={ref}
                  label="On Taxable Estates Over This Amount"
                  placeholder="On Taxable Estates Over This Amount"
                  leftIcon="fa fa-dollar-sign"
                  allowNegative={false}
                  value={value}
                  formVariant={errors.StateTaxLowerLimitAmount ? 'error' : undefined}
                  helperText={errors.StateTaxLowerLimitAmount?.message}
                  onValueChange={({ floatValue }) => {
                    onChange(floatValue);
                  }}
                  mt="16"
                />
              )}
            />

            <Separator my="16" />
          </>
        )}

        <Text>{options.PrincipalName}&apos;s Federal Estate Tax</Text>

        <Controller
          control={control}
          name="FederalTaxRate"
          render={({ field: fieldValue }) => (
            <InputNumberMask
              {...fieldValue}
              label="Effective Tax Rate"
              placeholder="Effective Tax Rate"
              rightIcon="far fa-percent"
              decimalScale={2}
              allowNegative={false}
              thousandSeparator={false}
              formVariant={errors.FederalTaxRate ? 'error' : undefined}
              helperText={errors.FederalTaxRate?.message}
              maxLength={3}
            />
          )}
        />

        <Controller
          control={control}
          name="FederalTaxLowerLimitAmount"
          render={({ field: { value, onChange, ref } }) => (
            <InputNumberMask
              ref={ref}
              label="On Taxable Estates Over This Amount"
              placeholder="On Taxable Estates Over This Amount"
              leftIcon="fa fa-dollar-sign"
              allowNegative={false}
              value={value}
              formVariant={errors.StateTaxLowerLimitAmount ? 'error' : undefined}
              helperText={errors.StateTaxLowerLimitAmount?.message}
              onValueChange={({ floatValue }) => {
                onChange(floatValue);
              }}
              mt="16"
            />
          )}
        />
      </Box>

      {options.SpouseName && (
        <>
          <Separator />

          <Box p="16">
            {options.SpouseHasEstateTax && (
              <>
                <Text>
                  {options.SpouseName}&apos;s {options.SpouseFilingState} State Estate Tax
                </Text>

                <Controller
                  control={control}
                  name="SpouseStateTaxRate"
                  render={({ field: fieldValue }) => (
                    <InputNumberMask
                      {...fieldValue}
                      label="Effective Tax Rate"
                      placeholder="Effective Tax Rate"
                      rightIcon="far fa-percent"
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={false}
                      formVariant={errors.SpouseStateTaxRate ? 'error' : undefined}
                      helperText={errors.SpouseStateTaxRate?.message}
                      maxLength={3}
                    />
                  )}
                />

                <Controller
                  control={control}
                  name="SpouseStateTaxLowerLimitAmount"
                  render={({ field: { value, onChange, ref } }) => (
                    <InputNumberMask
                      ref={ref}
                      label="On Taxable Estates Over This Amount"
                      placeholder="On Taxable Estates Over This Amount"
                      leftIcon="fa fa-dollar-sign"
                      allowNegative={false}
                      value={value}
                      formVariant={errors.SpouseStateTaxLowerLimitAmount ? 'error' : undefined}
                      helperText={errors.SpouseStateTaxLowerLimitAmount?.message}
                      onValueChange={({ floatValue }) => {
                        onChange(floatValue);
                      }}
                      mt="16"
                    />
                  )}
                />

                <Separator my="16" />
              </>
            )}

            <Text>{options.SpouseName}&apos;s Federal Estate Tax</Text>

            <Controller
              control={control}
              name="SpouseFederalTaxRate"
              render={({ field: fieldValue }) => (
                <InputNumberMask
                  {...fieldValue}
                  label="Effective Tax Rate"
                  placeholder="Effective Tax Rate"
                  rightIcon="far fa-percent"
                  decimalScale={2}
                  allowNegative={false}
                  thousandSeparator={false}
                  formVariant={errors.SpouseFederalTaxRate ? 'error' : undefined}
                  helperText={errors.SpouseFederalTaxRate?.message}
                  maxLength={3}
                />
              )}
            />

            <Controller
              control={control}
              name="SpouseFederalTaxLowerLimitAmount"
              render={({ field: { value, onChange, ref } }) => (
                <InputNumberMask
                  ref={ref}
                  label="On Taxable Estates Over This Amount"
                  placeholder="On Taxable Estates Over This Amount"
                  leftIcon="fa fa-dollar-sign"
                  allowNegative={false}
                  value={value}
                  formVariant={errors.SpouseFederalTaxLowerLimitAmount ? 'error' : undefined}
                  helperText={errors.SpouseFederalTaxLowerLimitAmount?.message}
                  onValueChange={({ floatValue }) => {
                    onChange(floatValue);
                  }}
                  mt="16"
                />
              )}
            />
          </Box>
        </>
      )}
    </>
  );
};
